<svg *ngIf="!isIE11Browser" [ngClass]="[className]">
  <use [attr.xlink:href]="'assets/images/sprite.svg#' + type"></use>
</svg>
<div *ngIf="isIE11Browser && type != 'sort-asc'  " [ngClass]="[className]" [innerHTML]="safeHTML">
</div>

<span *ngIf="isIE11Browser && type == 'sort-asc'  " [ngClass]="[className]" [innerHTML]="safeHTML">
</span>
